{
  "HELP_CENTER": {
    "TITLE": "Súgóközpont",
    "NEW_PAGE": {
      "DESCRIPTION": "Hozz létre önkiszolgáló súgóközpont-portálokat ügyfeleid számára. Segíts nekik gyorsan, várakozás nélkül megtalálni a válaszokat. Egyszerűsítsd a megkereséseket, növeld az ügynökök hatékonyságát, és emeld magasabb szintre az ügyfélszolgálatot.",
      "CREATE_PORTAL_BUTTON": "Portál létrehozása"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Névtelen"
    },
    "HEADER": {
      "FILTER": "Szűrés",
      "SORT": "Rendezés",
      "LOCALE": "Nyelv",
      "SETTINGS_BUTTON": "Beállítások",
      "NEW_BUTTON": "Új bejegyzés",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publikált",
        "DRAFT": "Piszkozat",
        "ARCHIVED": "Archivált"
      },
      "TITLES": {
        "ALL_ARTICLES": "Minden bejegyzés",
        "MINE": "Saját bejegyzések",
        "DRAFT": "Draft bejegyzések",
        "ARCHIVED": "Archivált bejegyzések"
      },
      "LOCALE_SELECT": {
        "TITLE": "Nyelv kiválasztása",
        "PLACEHOLDER": "Nyelv kiválasztása",
        "NO_RESULT": "Nem található nyelv",
        "SEARCH_PLACEHOLDER": "Nyelv keresése"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Minden bejegyzés",
      "PUBLISH_BUTTON": "Publikálás",
      "MOVE_TO_ARCHIVE_BUTTON": "Archiválás",
      "PREVIEW": "Előnézet",
      "ADD_TRANSLATION": "Fordítás hozzáadása",
      "OPEN_SIDEBAR": "Oldalsáv megnyitása",
      "CLOSE_SIDEBAR": "Oldalsáv becsukás",
      "SAVING": "Mentés...",
      "SAVED": "Mentve"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Kép feltöltése",
        "UPLOADING": "Feltöltés...",
        "SUCCESS": "Képfeltöltés sikeres",
        "ERROR": "Hiba a kép feltöltésekor",
        "UN_AUTHORIZED_ERROR": "Nincs jogosultságod képek feltöltésére",
        "ERROR_FILE_SIZE": "A kép mérete kevesebb, mint {size} MB",
        "ERROR_FILE_FORMAT": "A kép formátuma legyen jpg, jpeg vagy png",
        "ERROR_FILE_DIMENSIONS": "A kép felbontása kevesebb legyen, mint 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Horgony beszúrása",
        "TITLE": "Horgony beszúrása",
        "SUBMIT": "Beszúrás",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Bejegyzés beállítások",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategória",
          "TITLE": "Kategória választás",
          "PLACEHOLDER": "Kategória választás",
          "NO_RESULT": "Nincsenek kategóriák",
          "SEARCH_PLACEHOLDER": "Kategória keresés"
        },
        "AUTHOR": {
          "LABEL": "Szerző",
          "TITLE": "Szerző kiválasztás",
          "PLACEHOLDER": "Szerző kiválasztás",
          "NO_RESULT": "Nincsenek szerzők",
          "SEARCH_PLACEHOLDER": "Szerző keresés"
        },
        "META_TITLE": {
          "LABEL": "Meta cím",
          "PLACEHOLDER": "Meta cím megadása"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta leírás",
          "PLACEHOLDER": "Adj hozzá meta leírást a jobb SEO eredmények érdekében..."
        },
        "META_TAGS": {
          "LABEL": "Meta tagek",
          "PLACEHOLDER": "Adj hozzá meta címkéket vesszőkkel elválasztva..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Bejegyzés archiválása",
        "DELETE": "Cikk törlése"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Kategorizálhatatlan",
      "SEARCH_RESULTS": "Keresési eredmények erre: {query}",
      "EMPTY_TEXT": "Cikkek keresése a válaszokba való beillesztéshez.",
      "SEARCH_LOADER": "Keresés...",
      "INSERT_ARTICLE": "Beszúrás",
      "NO_RESULT": "Nem található cikk",
      "COPY_LINK": "Cikk hivatkozásának másolása a vágólapra",
      "OPEN_LINK": "Cikk megnyitása új lapon",
      "PREVIEW_LINK": "Cikk előnézete"
    },
    "PORTAL": {
      "HEADER": "Portálok",
      "DEFAULT": "Alapértelmezett",
      "NEW_BUTTON": "Új portál",
      "ACTIVE_BADGE": "aktív",
      "CHOOSE_LOCALE_LABEL": "Terület választása",
      "LOADING_MESSAGE": "Portálok betöltése...",
      "ARTICLES_LABEL": "bejegyzések",
      "NO_PORTALS_MESSAGE": "Nincsenek elérhető portálok",
      "ADD_NEW_LOCALE": "Új terület hozzáadása",
      "POPOVER": {
        "TITLE": "Portálok",
        "PORTAL_SETTINGS": "Portál beállítások",
        "SUBTITLE": "Több portálja van, és mindegyik portálhoz különböző területi beállításokat adhat meg.",
        "CANCEL_BUTTON_LABEL": "Mégse",
        "CHOOSE_LOCALE_BUTTON": "Terület választása"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "bejegyzések",
            "ADD": "Terület hozzáadása",
            "VISIT": "Oldal meglátogatása",
            "SETTINGS": "Beállítások",
            "DELETE": "Törlés"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portál beállítások",
            "ITEMS": {
              "NAME": "Név",
              "DOMAIN": "Egyedi domain",
              "SLUG": "Slug",
              "TITLE": "Portál címe",
              "THEME": "Témaszín",
              "SUB_TEXT": "Portál alszövege"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Elérhető területek",
            "TABLE": {
              "NAME": "Terület neve",
              "CODE": "Terület kódja",
              "ARTICLE_COUNT": "Bejegyzések száma",
              "CATEGORIES": "Kategóriák száma",
              "SWAP": "Csere",
              "DELETE": "Törlés",
              "DEFAULT_LOCALE": "Alapértelmezett"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Portál törlése",
          "MESSAGE": "Biztosan törölni szeretnéd ezt a portált?",
          "YES": "Igen, portál törlése",
          "NO": "Nem, portál megtartása",
          "API": {
            "DELETE_SUCCESS": "Portál sikeresen törölve",
            "DELETE_ERROR": "Hiba a portál törlése közben"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Portál szerkesztése",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Alapinformációk"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portál személyreszabás"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategóriák"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Nyelvek"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategóriák, itt:",
          "NEW_CATEGORY": "Új kategória",
          "TABLE": {
            "NAME": "Név",
            "DESCRIPTION": "Leírás",
            "LOCALE": "Nyelv",
            "ARTICLE_COUNT": "Bejegyzések száma",
            "ACTION_BUTTON": {
              "EDIT": "Kategória szerkesztése",
              "DELETE": "Kategória törlése"
            },
            "EMPTY_TEXT": "Nincsenek kategóriák"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Alapbeállítások frissítése"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Súgó információk",
            "BODY": "Általános információk a portálról"
          },
          "CUSTOMIZATION": {
            "TITLE": "Súgó testreszabása",
            "BODY": "Portál személyreszabása"
          },
          "FINISH": {
            "TITLE": "Kész is! 🎉",
            "BODY": "Kész is!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Vissza",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Portál létrehozása",
            "TITLE": "Súgó információk",
            "CREATE_BASIC_SETTING_BUTTON": "Portál általános beállításainak létrehozása"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portál személyreszabása",
            "TITLE": "Súgó testreszabása",
            "UPDATE_PORTAL_BUTTON": "Portál beállítások frissítése"
          },
          "FINISH_PAGE": {
            "TITLE": "Íme! 🎉 Minden készen áll!",
            "MESSAGE": "Most már láthatod ezt a létrehozott portált az összes portál oldalán.",
            "FINISH": "Ugrás az összes portál oldalára"
          }
        },
        "LOGO": {
          "LABEL": "Logó",
          "UPLOAD_BUTTON": "Logó feltöltése",
          "HELP_TEXT": "Ez a logó megjelenik a portál fejlécében.",
          "IMAGE_UPLOAD_SUCCESS": "Logó sikeresen feltöltve",
          "IMAGE_UPLOAD_ERROR": "Logó sikeresen törölve",
          "IMAGE_DELETE_ERROR": "Hiba a logó törlése közben"
        },
        "NAME": {
          "LABEL": "Név",
          "PLACEHOLDER": "Portál neve",
          "HELP_TEXT": "A név belsőleg a nyilvános portálon kerül felhasználásra.",
          "ERROR": "Név kötelező"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portál slug URL-ekhez",
          "ERROR": "Slug megadása kötelező"
        },
        "DOMAIN": {
          "LABEL": "Egyedi domain",
          "PLACEHOLDER": "Portál egyedi domain",
          "HELP_TEXT": "Csak akkor add meg, ha egyedi domaint szeretnél használni a portáljaidhoz. Pl.: {exampleURL}",
          "ERROR": "Adj meg egy érvényes domain URL-t"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Főoldal link",
          "PLACEHOLDER": "Portál főoldal link",
          "HELP_TEXT": "A link, amellyel visszatérhetsz a portálról a kezdőlapra. Pl.: {exampleURL}",
          "ERROR": "Adj meg egy érvényes kezdőlap URL-jét"
        },
        "THEME_COLOR": {
          "LABEL": "Portál témaszíne",
          "HELP_TEXT": "Ez a szín fog megjelenni a portál témaszíneként."
        },
        "PAGE_TITLE": {
          "LABEL": "Oldalcím",
          "PLACEHOLDER": "Portál oldalcím",
          "HELP_TEXT": "Az oldal címe a nyilvános portálon kerül felhasználásra.",
          "ERROR": "Oldalcím megadása kötelező"
        },
        "HEADER_TEXT": {
          "LABEL": "Fejléc szöveg",
          "PLACEHOLDER": "Portál fejléc szöveg",
          "HELP_TEXT": "A portál fejléc szövege a nyilvános portálon kerül felhasználásra.",
          "ERROR": "Portál fejléc szöveg megadása kötelező"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portál sikeresen létrehozva.",
          "ERROR_MESSAGE_FOR_BASIC": "Nem sikerült létrehozni a portált. Kérlek, próbáld újra.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portál sikeresen frissítve.",
          "ERROR_MESSAGE_FOR_UPDATE": "Nem sikerült frissíteni a portált. Kérlek, próbáld újra."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Új terület hozzáadása",
        "SUB_TITLE": "Ezzel egy új nyelv- és országkódot adsz hozzá az elérhető fordítási listához.",
        "PORTAL": "Portál",
        "LOCALE": {
          "LABEL": "Nyelv",
          "PLACEHOLDER": "Terület választása",
          "ERROR": "Terület megadása kötelező"
        },
        "BUTTONS": {
          "CREATE": "Terület létrehozása",
          "CANCEL": "Mégse"
        },
        "API": {
          "SUCCESS_MESSAGE": "Terület sikeresen hozzáadva",
          "ERROR_MESSAGE": "Nem sikerült területet hozzáadni. Kérlek, próbáld újra."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Alapértelmezett területi beállítás sikeresen frissítve",
          "ERROR_MESSAGE": "Nem sikerült frissíteni az alapértelmezett területi beállítást. Kérlek, próbáld újra."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Terület sikeresen eltávolítva a portálról",
          "ERROR_MESSAGE": "Nem sikerült eltávolítani a területet a portálról. Kérlek, próbáld újra."
        }
      }
    },
    "TABLE": {
      "404": "Nincs a keresésnek megfelelő cikk 🔍",
      "LOADING_MESSAGE": "Bejegyzések betöltése...",
      "NO_ARTICLES": "Nincsenek elérhető cikkek",
      "HEADERS": {
        "TITLE": "Cím",
        "CATEGORY": "Kategória",
        "READ_COUNT": "Megtekintések",
        "STATUS": "Státusz",
        "LAST_EDITED": "Utoljára szerkesztve"
      },
      "COLUMNS": {
        "BY": "általa:",
        "AUTHOR_NOT_AVAILABLE": "A szerző nem elérhető"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Bejegyzés betöltése...",
      "TITLE_PLACEHOLDER": "A cikk címét írd ide",
      "CONTENT_PLACEHOLDER": "Írd ide a cikkedet",
      "API": {
        "ERROR": "Hiba a cikk elmentésekor"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Hiba a cikk publikálásakor",
        "SUCCESS": "Cikk sikeresen publikálva"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Hiba a cikk archiválásakor",
        "SUCCESS": "Cikk sikeresen archiválva"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Hiba történt a cikk Draft állapotba helyezésekor",
        "SUCCESS": "A cikk sikeresen Draft állapotba került"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Törlés megerősítése",
          "MESSAGE": "Biztosan törölni szeretnéd a cikket?",
          "YES": "Igen, Törlés",
          "NO": "Nem, megtartás"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Cikk sikeresen törölve",
        "ERROR_MESSAGE": "Hiba a cikk törlésekor"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Kérjük, adj hozzá a cikk címét és tartalmát, ezután csak Te tudod majd frissíteni a beállításokat"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Keresés a bejegyzések között"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Kategória létrehozása",
        "SUB_TITLE": "A kategóriát a nyilvános portálon fogják használni a cikkek kategorizálására.",
        "PORTAL": "Portál",
        "LOCALE": "Nyelv",
        "NAME": {
          "LABEL": "Név",
          "PLACEHOLDER": "Kategória neve",
          "HELP_TEXT": "A kategória neve és ikonja a nyilvános portálon a cikkek kategorizálására szolgál.",
          "ERROR": "Név kötelező"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategória slug az URL-ekhez",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug megadása kötelező"
        },
        "DESCRIPTION": {
          "LABEL": "Leírás",
          "PLACEHOLDER": "Adj egy rövid leírást a kategóriához.",
          "ERROR": "Leírás megadása kötelező"
        },
        "BUTTONS": {
          "CREATE": "Kategória létrehozása",
          "CANCEL": "Mégse"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategória létrehozva",
          "ERROR_MESSAGE": "Nem sikerült létrehozni a kategóriát"
        }
      },
      "EDIT": {
        "TITLE": "Kategória szerkesztése",
        "SUB_TITLE": "A kategória szerkesztése frissíti a kategóriát a nyilvános portálon.",
        "PORTAL": "Portál",
        "LOCALE": "Nyelv",
        "NAME": {
          "LABEL": "Név",
          "PLACEHOLDER": "Kategória neve",
          "HELP_TEXT": "A kategória neve és ikonja a nyilvános portálon a cikkek kategorizálására szolgál.",
          "ERROR": "Név kötelező"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategória slug az URL-ekhez",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug megadása kötelező"
        },
        "DESCRIPTION": {
          "LABEL": "Leírás",
          "PLACEHOLDER": "Adj egy rövid leírást a kategóriához.",
          "ERROR": "Leírás megadása kötelező"
        },
        "BUTTONS": {
          "CREATE": "Kategória frissítése",
          "CANCEL": "Mégse"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategória frissítve",
          "ERROR_MESSAGE": "Nem sikerült frissíteni a kategóriát"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategória törölve",
          "ERROR_MESSAGE": "Nem sikerült törölni a kategóriát"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Cikkek keresése",
      "PLACEHOLDER": "Cikkek keresése",
      "NO_RESULT": "Nem található cikk",
      "SEARCHING": "Keresés...",
      "SEARCH_BUTTON": "Keresés",
      "INSERT_ARTICLE": "Link beillesztése",
      "IFRAME_ERROR": "Az URL üres vagy érvénytelen. A tartalom megjelenítése nem lehetséges.",
      "OPEN_ARTICLE_SEARCH": "Cikk beillesztése a Súgóközpontból",
      "SUCCESS_ARTICLE_INSERTED": "Cikk sikeresen beillesztve",
      "PREVIEW_LINK": "Cikk előnézete",
      "CANCEL": "Bezárás",
      "BACK": "Vissza",
      "BACK_RESULTS": "Vissza az eredményekhez"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Súgóközpont",
      "DESCRIPTION": "Hozzon létre felhasználóbarát önkiszolgáló portálokat. Segítse felhasználóit a cikkek 0-24 elérésében. Frissítse előfizetését, hogy engedélyezze ezt a funkciót.",
      "SELF_HOSTED_DESCRIPTION": "Hozzon létre felhasználóbarát önkiszolgáló portálokat. Segítse felhasználóit a cikkek 0-24 elérésében. Kérjük, lépjen kapcsolatba a rendszergazdával a funkció engedélyezéséhez.",
      "BUTTON": {
        "LEARN_MORE": "Tudj meg többet",
        "UPGRADE": "Frissítés"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Több portál",
          "DESCRIPTION": "Hozzon létre több súgóközpont-portált különböző termékekhez ugyanazon fiók használatával."
        },
        "LOCALES": {
          "TITLE": "Teljes körű támogatás a nyelvi beállításokhoz",
          "DESCRIPTION": "Lokalizálja a portált az Ön nyelvén. Az összes elérhető nyelvi beállítást támogatjuk, és lehetővé tesszük a fordítást minden cikkhez."
        },
        "SEO": {
          "TITLE": "SEO-barát design",
          "DESCRIPTION": "Testre szabhatja meta-címkéit, hogy SEO-barát oldalainkkal javítsa láthatóságát a keresőmotorokban."
        },
        "API": {
          "TITLE": "Teljes API támogatás",
          "DESCRIPTION": "Használja a portált fej nélküli CMS-ként harmadik féltől származó front-end keretrendszerekkel a mi API-ink segítségével."
        }
      }
    },
    "LOADING": "Betöltés...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} megtekintés | {count} megtekintés",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publikálás",
            "DRAFT": "Piszkozat",
            "ARCHIVE": "Archiválás",
            "DELETE": "Törlés"
          },
          "STATUS": {
            "DRAFT": "Piszkozat",
            "PUBLISHED": "Publikált",
            "ARCHIVED": "Archivált"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Kategorizálhatatlan"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Összes",
          "MINE": "Enyém",
          "DRAFT": "Piszkozat",
          "PUBLISHED": "Publikált",
          "ARCHIVED": "Archivált"
        },
        "CATEGORY": {
          "ALL": "Összes kategória"
        },
        "LOCALE": {
          "ALL": "Összes nyelv"
        },
        "NEW_ARTICLE": "Új cikk"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Írj egy cikket",
          "SUBTITLE": "Írj egy tartalmas cikket, vágjunk bele!",
          "BUTTON_LABEL": "Új cikk"
        },
        "MINE": {
          "TITLE": "Még nem írtál itt egyetlen cikket sem",
          "SUBTITLE": "Az összes általad írt cikk itt jelenik meg a gyors eléréshez."
        },
        "DRAFT": {
          "TITLE": "Nincsenek Draft cikkek",
          "SUBTITLE": "A Draft cikkek itt fognak megjelenni"
        },
        "PUBLISHED": {
          "TITLE": "Nincsenek publikált cikkek",
          "SUBTITLE": "A publikált cikkek itt fognak megjelenni"
        },
        "ARCHIVED": {
          "TITLE": "Az archívumban nincsenek cikkek",
          "SUBTITLE": "Az archivált cikkek nem jelennek meg a portálon, elavult vagy már nem használt oldalak megjelölésére használhatod."
        },
        "CATEGORY": {
          "TITLE": "Ebben a kategóriában nincsenek cikkek",
          "SUBTITLE": "Az ebbe a kategóriába tartozó cikkek itt fognak megjelenni"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Új kategória",
        "EDIT_CATEGORY": "Kategória szerkesztése",
        "CATEGORIES_COUNT": "{n} kategória | {n} kategória",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategóriák ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} cikk) | {categoryName} ({categoryCount} cikk)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nincsenek kategóriák",
        "SUBTITLE": "A kategóriák itt fognak megjelenni. Kategóriát az „Új kategória” gombra kattintva adhatsz hozzá."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} cikk | {count} cikk",
        "EXPAND": "Alkategóriák megjelenítése",
        "COLLAPSE": "Alkategóriák elrejtése",
        "MENU": {
          "NEW_ARTICLE": "Új cikk",
          "ADD_SUBCATEGORY": "Alkategória hozzáadása",
          "EDIT": "Szerkesztés",
          "DELETE": "Törlés"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategória létrehozva",
            "ERROR_MESSAGE": "Nem sikerült létrehozni a kategóriát"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategória frissítve",
            "ERROR_MESSAGE": "Nem sikerült frissíteni a kategóriát"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategória törölve",
            "ERROR_MESSAGE": "Nem sikerült törölni a kategóriát"
          },
          "CONFIRM": {
            "TITLE": "Kategória törlése",
            "DESCRIPTION": "Biztosan törölni szeretnéd ezt a kategóriát? A hozzá tartozó cikkek kategorizálatlanná válnak.",
            "DESCRIPTION_WITH_CHILDREN": "Biztosan törölni szeretnéd ezt a kategóriát? A hozzá tartozó cikkek kategorizálatlanná válnak, és a {count} alkategóriája a felső szintre kerül. | Biztosan törölni szeretnéd ezt a kategóriát? A hozzá tartozó cikkek kategorizálatlanná válnak, és a {count} alkategóriája a felső szintre kerül.",
            "CONFIRM": "Törlés"
          }
        },
        "HEADER": {
          "CREATE": "Kategória létrehozása",
          "EDIT": "Kategória szerkesztése",
          "DESCRIPTION": "A kategória szerkesztése frissíti a kategóriát a nyilvános portálon.",
          "PORTAL": "Portál",
          "LOCALE": "Nyelv"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Név",
            "PLACEHOLDER": "Kategória neve",
            "ERROR": "Név kötelező"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Kategória slug az URL-ekhez",
            "ERROR": "Slug megadása kötelező",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Leírás",
            "PLACEHOLDER": "Adj egy rövid leírást a kategóriához.",
            "ERROR": "Leírás megadása kötelező"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Szülőkategória",
            "PLACEHOLDER": "Válassz szülőkategóriát",
            "NONE": "Nincs (felső szint)"
          }
        },
        "BUTTONS": {
          "CREATE": "Létrehozás",
          "EDIT": "Frissítés",
          "CANCEL": "Mégse"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nincs elérhető nyelv | {n} nyelv | {n} nyelv",
      "NEW_LOCALE_BUTTON_TEXT": "Új nyelv",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} cikk | {count} cikk",
        "CATEGORIES_COUNT": "{count} kategória | {count} kategória",
        "DEFAULT": "Alapértelmezett",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Beállítás alapértelmezettként",
          "DELETE": "Törlés"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Új terület hozzáadása",
        "DESCRIPTION": "Válaszd ki a nyelvet, amelyen ez a cikk íródik. Ez bekerül a fordítási listádba, és később további nyelveket is hozzáadhatsz.",
        "COMBOBOX": {
          "PLACEHOLDER": "Nyelv kiválasztása..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Terület sikeresen hozzáadva",
          "ERROR_MESSAGE": "Nem sikerült területet hozzáadni. Kérlek, próbáld újra."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Mentés...",
          "SAVED": "Mentve"
        },
        "PREVIEW": "Előnézet",
        "PUBLISH": "Publikálás",
        "DRAFT": "Piszkozat",
        "ARCHIVE": "Archiválás",
        "BACK_TO_ARTICLES": "Vissza a cikkekhez"
      },
      "DRAFT": {
        "PENDING_LABEL": "Közzé nem tett módosítások",
        "PROMOTE": "Módosítások közzététele",
        "DISCARD": "Módosítások elvetése",
        "PROMOTE_SUCCESS": "A Draft módosításai közzétéve az élő cikkben",
        "PROMOTE_ERROR": "Nem sikerült közzétenni a Draft módosításait",
        "DISCARD_SUCCESS": "A Draft módosításai elvetve",
        "DISCARD_ERROR": "Nem sikerült elvetni a Draft módosításait"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Verzióelőzmények",
        "TITLE": "Verzióelőzmények",
        "BACK": "Vissza a cikkhez",
        "LOADING": "Verziók betöltése...",
        "EMPTY": "Még nincsenek verziók. A cikk módosításai itt fognak megjelenni.",
        "EMPTY_CONTENT": "Ennek a verziónak nincs tartalma.",
        "CURRENT_BADGE": "Jelenlegi",
        "RESTORED_BADGE": "Visszaállítva",
        "AUTOMATED_USER": "Automatikus frissítés",
        "RESTORE": "Verzió visszaállítása",
        "RESTORE_DIALOG": {
          "TITLE": "Visszaállítod ezt a verziót?",
          "DESCRIPTION": "A cikk visszaáll erre a verzióra. Semmi nem vész el — a jelenlegi szöveg megmarad az előzményekben, és ha a cikk már publikálva van, a nyilvános oldal továbbra is az élő verziót mutatja, amíg nem publikálod ezt a módosítást.",
          "CONFIRM": "Visszaállítás"
        },
        "RESTORE_SUCCESS": "Verzió visszaállítva",
        "RESTORE_ERROR": "Nem sikerült visszaállítani ezt a verziót",
        "FETCH_ERROR": "Nem sikerült betölteni a verzióelőzményeket"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "További tulajdonságok",
        "TRANSLATE": "Fordítás",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Kategorizálhatatlan",
        "EDITOR_PLACEHOLDER": "Írj valamit...",
        "HTML_EMBED": {
          "TITLE": "Egyéni HTML beszúrása",
          "DESCRIPTION": "Illesszen be nyers HTML-kódot, például iframe-et, beágyazást vagy widget-részletet. A közzétett cikkben változatlanul jelenik meg.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Beszúrás"
        },
        "PRIMARY_CATEGORY": "Elsődleges kategória"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Cikk tulajdonságai",
        "SLUG": "Slug",
        "EDIT_SLUG": "Slug szerkesztése",
        "META_DESCRIPTION": "Meta leírás",
        "META_DESCRIPTION_PLACEHOLDER": "Meta leírás hozzáadása",
        "META_TITLE": "Meta cím",
        "META_TITLE_PLACEHOLDER": "Meta cím hozzáadása",
        "META_TAGS": "Meta tagek",
        "META_TAGS_PLACEHOLDER": "Meta tagek hozzáadása",
        "SET_AS_HOMEPAGE": "Beállítás kezdőlapként",
        "SET_AS_HOMEPAGE_HELP": "A cikk jelenjen meg a súgóközpont kezdőlapjaként ezen a nyelven. Írja be a tartalomba ezt: {'{{NAV}}'}, hogy a keresés és a kategóriák is megjelenjenek.",
        "LANGUAGE_MUTATIONS": "Nyelvi változatok",
        "LANGUAGE_MUTATIONS_EMPTY": "Még nincsenek kapcsolt cikkek",
        "ADD_MUTATION": "Hozzáadás",
        "REMOVE_MUTATION": "Eltávolítás"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Nyelvi változatok összekapcsolása",
        "SEARCH_PLACEHOLDER": "Cikkek keresése cím szerint",
        "EMPTY": "Nincs találat",
        "CANCEL": "Mégse",
        "ADD_SELECTED": "Kijelöltek hozzáadása",
        "SUCCESS": "Változatok frissítve",
        "ERROR": "Nem sikerült frissíteni a változatokat"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Cikk fordítása",
        "DESCRIPTION": "Válassza ki azokat a nyelveket, amelyekre le szeretné fordítani ezt a cikket. A már lefordított nyelvek újra lefordításra kerülnek egy Draft változatba, ellenőrzés céljából.",
        "EMPTY": "Nincsenek elérhető más nyelvek.",
        "CONNECTED_BADGE": "Lefordítva",
        "CANCEL": "Mégse",
        "TRANSLATE": "Fordítás",
        "SUCCESS": "A fordítás hamarosan elkezdődik. A lefordított cikkek hamarosan megjelennek nyelvi változatokként.",
        "ERROR": "Nem sikerült elindítani a fordítást"
      },
      "SLUG_DIALOG": {
        "TITLE": "Cikk URL-jének szerkesztése",
        "DESCRIPTION": "Módosítsa a cikk slugjának leíró részét. A régi linkek továbbra is működnek, automatikusan ide irányítanak.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "A számelőtag állandó azonosító, nem módosítható.",
        "PREVIEW": "Cikk URL-je",
        "CANCEL": "Mégse",
        "SAVE": "Mentés",
        "SUCCESS": "A cikk URL-je frissítve",
        "ERROR": "A cikk URL-jének frissítése nem sikerült"
      },
      "API": {
        "ERROR": "Hiba a cikk elmentésekor"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Új portál",
      "PORTALS": "Portálok",
      "CREATE_PORTAL": "Több portál létrehozása és kezelése",
      "ARTICLES": "bejegyzések",
      "DOMAIN": "domain",
      "PORTAL_NAME": "Portál neve"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Új portál létrehozása",
      "DESCRIPTION": "Adj nevet a portálodnak, és hozz létre egy felhasználóbarát URL slugot. Mindkettőt később is módosíthatod a beállításokban.",
      "CONFIRM_BUTTON_LABEL": "Létrehozás",
      "NAME": {
        "LABEL": "Név",
        "PLACEHOLDER": "Felhasználói útmutató",
        "MESSAGE": "Válassz nevet a portálodnak.",
        "ERROR": "Név kötelező"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "felhasznaloi-utmutato",
        "ERROR": "Slug megadása kötelező",
        "FORMAT_ERROR": "Csak betűket, számokat és kötőjeleket használjon, például: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logó",
          "IMAGE_UPLOAD_ERROR": "A képet nem sikerült feltölteni! Próbáld újra",
          "IMAGE_UPLOAD_SUCCESS": "A kép sikeresen hozzáadva. A logó mentéséhez kattints a Mentés gombra.",
          "IMAGE_DELETE_SUCCESS": "Logó sikeresen törölve",
          "IMAGE_DELETE_ERROR": "Nem sikerült törölni a logót",
          "IMAGE_UPLOAD_SIZE_ERROR": "A kép mérete kevesebb, mint {size} MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Fejléckép",
          "HELP_TEXT": "Opcionális, teljes szélességű háttérkép a súgóközpont kezdőlapján, a középre igazított keresőmező mögött.",
          "IMAGE_UPLOAD_ERROR": "A kép feltöltése nem sikerült! Próbálja újra",
          "IMAGE_UPLOAD_SUCCESS": "A kép sikeresen hozzáadva. A fejléckép mentéséhez kattintson a módosítások mentésére",
          "IMAGE_DELETE_SUCCESS": "A fejléckép sikeresen törölve",
          "IMAGE_DELETE_ERROR": "A fejléckép törlése nem sikerült",
          "IMAGE_UPLOAD_SIZE_ERROR": "A kép mérete legyen kisebb, mint {size} MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Kezdőlap cikkek",
          "EMPTY": "Nincs kezdőlapként beállított cikk. Egy cikk tulajdonságainál állíthat be egyet.",
          "HELP_TEXT": "Az egyes nyelvek kezdőlapjaként megjelenő cikk. Kattintson rá a megnyitásához, vagy távolítsa el az alapértelmezett kezdőlap visszaállításához.",
          "REMOVE": "Eltávolítás",
          "REMOVE_SUCCESS": "A kezdőlap cikk eltávolítva",
          "REMOVE_ERROR": "A kezdőlap cikk eltávolítása nem sikerült"
        },
        "NAME": {
          "LABEL": "Név",
          "PLACEHOLDER": "Portál neve",
          "ERROR": "Név kötelező"
        },
        "HEADER_TEXT": {
          "LABEL": "Fejléc szöveg",
          "PLACEHOLDER": "Portál fejléc szöveg"
        },
        "PAGE_TITLE": {
          "LABEL": "Oldalcím",
          "PLACEHOLDER": "Portál oldalcím"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Főoldal link",
          "PLACEHOLDER": "Portál főoldal link",
          "ERROR": "Érvénytelen URL. A főoldal linknek 'http://' vagy 'https://' előtaggal kell kezdődnie."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portál slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Élő chat widget",
          "PLACEHOLDER": "Válassz élő chat widgetet",
          "HELP_TEXT": "Válaszd ki az élő chat widgetet, amely megjelenik a súgóközpontodban"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Nyilvánosan hozzáférhető",
          "HELP_TEXT": "Tegye a portált mindenki számára elérhetővé a linkkel.",
          "OPTIONS": {
            "PUBLIC": "Igen",
            "PRIVATE": "Nem"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Hivatkozás célja",
          "HELP_TEXT": "Válassza ki, hogy a cikkeken belüli hivatkozások az aktuális ablakban vagy egy újban nyíljanak meg.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Aktuális ablak",
            "NEW_WINDOW": "Új ablak"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Alapértelmezett képméret",
          "HELP_TEXT": "A cikkbe beszúrt minden képre alkalmazott méret. Válassza az Eredeti lehetőséget, hogy a képeket saját méretükben szúrja be, és helyette válasszon méretet képenként."
        },
        "BRAND_COLOR": {
          "LABEL": "Márka színe"
        },
        "CUSTOM_HTML": {
          "LABEL": "Egyéni HTML",
          "PLACEHOLDER": "<!-- Illessze be ide az analitikai vagy nyomkövető kódrészletet -->",
          "HELP_TEXT": "Bekerül minden súgóközpont-oldal <body> címkéjének elejére. Használja Google Analytics, Google Tag Manager vagy bármilyen más nyomkövető kódrészlethez. A kód pontosan úgy jelenik meg, ahogyan megadta, és nincs ellenőrizve."
        },
        "SAVE_CHANGES": "Változtatások mentése"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Egyedi domain",
          "LABEL": "Egyedi domain:",
          "DESCRIPTION": "A portálodat egyedi domainen is üzemeltetheted. Ha például a weboldalad yourdomain.com, és szeretnéd, hogy a portálod a docs.yourdomain.com címen legyen elérhető, egyszerűen add meg ezt a mezőben.",
          "PLACEHOLDER": "Portál egyedi domain",
          "EDIT_BUTTON": "Egyedi domain szerkesztése",
          "ADD_BUTTON": "Egyedi domain hozzáadása",
          "DIALOG": {
            "ADD_HEADER": "Egyedi domain hozzáadása",
            "EDIT_HEADER": "Egyedi domain szerkesztése",
            "ADD_CONFIRM_BUTTON_LABEL": "Domain hozzáadása",
            "EDIT_CONFIRM_BUTTON_LABEL": "Domain frissítése",
            "LABEL": "Egyedi domain",
            "PLACEHOLDER": "Portál egyedi domain",
            "ERROR": "Egyedi domain megadása kötelező"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS konfiguráció",
            "DESCRIPTION": "Jelentkezzen be a DNS-szolgáltatójánál lévő fiókjába, és adja hozzá az alábbi CNAME rekordot az aldomainjéhez.",
            "HELP_TEXT": "Ha ezzel elkészültél, fordulhatsz ügyfélszolgálatunkhoz az automatikusan generált SSL-tanúsítvány igényléséhez.",
            "CONFIRM_BUTTON_LABEL": "Rendben!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "{portalName} törlése",
          "HEADER": "Portál törlése",
          "DESCRIPTION": "Véglegesen törli ezt a portált. Ez a művelet nem vonható vissza.",
          "DIALOG": {
            "HEADER": "Biztosan törölni szeretnéd a következőt: {portalName}?",
            "DESCRIPTION": "Ez egy végleges művelet, amely nem vonható vissza.",
            "CONFIRM_BUTTON_LABEL": "Törlés"
          }
        },
        "EDIT_CONFIGURATION": "Konfiguráció szerkesztése"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portál sikeresen létrehozva",
          "ERROR_MESSAGE": "Nem sikerült létrehozni a portált"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portál sikeresen frissítve",
          "ERROR_MESSAGE": "Nem sikerült frissíteni a portált"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Csatolmányok",
      "DRAFT_BADGE": "Piszkozat",
      "ADD_BUTTON": "Fájl hozzáadása",
      "DROP_HERE": "Húzd ide a fájlokat",
      "COPY_LINK": "Link másolása",
      "LINK_COPIED": "Link a vágólapra másolva",
      "COPY_FAILED": "Nem sikerült másolni a linket",
      "DELETE": "Törlés",
      "CANCEL": "Mégse",
      "QUEUED": "Sorban áll",
      "UPLOADING": "Feltöltés",
      "UPLOAD_FAILED": "Nem sikerült feltölteni a fájlt",
      "FILE_TOO_LARGE": "A fájl meghaladja a 40 MB-os méretkorlátot"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Fordítási szótár",
        "DESCRIPTION": "Az itt megadott kifejezések bekerülnek az AI fordítási promptjába, így mindig ugyanúgy kerülnek lefordításra. A kulcskifejezés {locale} nyelven van megadva."
      },
      "NEW_TERM": "Új kifejezés",
      "EMPTY_STATE": {
        "TITLE": "Még nincsenek szótári kifejezések",
        "SUBTITLE": "Adj hozzá egy kifejezést és annak fordítását minden nyelvhez. Amikor egy cikket lefordítanak, ezek a kifejezések érvényesülnek, így a termék szóhasználata következetes marad."
      },
      "LIST": {
        "TERM": "Kifejezés",
        "TRANSLATIONS": "Fordítások",
        "ACTIONS": "Műveletek"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Kifejezés hozzáadása",
          "EDIT": "Kifejezés szerkesztése",
          "DESCRIPTION": "Az alábbi kifejezés érvényesül a súgóközpont-cikkek AI fordítása során.",
          "PORTAL": "Portál",
          "PRIMARY_LANGUAGE": "Elsődleges nyelv"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Kifejezés ({locale})",
            "PLACEHOLDER": "Postafiók",
            "ERROR": "A kifejezés megadása kötelező"
          },
          "DESCRIPTION": {
            "LABEL": "Kontextus / megjegyzések (opcionális)",
            "PLACEHOLDER": "Mikor és hogyan használatos ez a kifejezés, hogy segítse a fordítót az egyértelműsítésben."
          },
          "TRANSLATIONS": "Fordítások",
          "TRANSLATION_PLACEHOLDER": "Hagyd üresen, hogy az AI szabadon fordíthassa",
          "AUTO_TRANSLATE": {
            "BUTTON": "Összes automatikus fordítása",
            "CONFIRM": "Lefordítod {count} nyelvre AI-val?",
            "CONFIRM_BUTTON": "Fordítás",
            "CANCEL": "Mégse",
            "SUCCESS": "A fordítások elkészültek – nézd át és mentsd el",
            "ERROR": "Nem sikerült automatikusan lefordítani, kérlek, próbáld újra"
          }
        },
        "BUTTONS": {
          "CREATE": "Kifejezés hozzáadása",
          "EDIT": "Mentés",
          "CANCEL": "Mégse"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kifejezés sikeresen hozzáadva",
            "ERROR_MESSAGE": "Nem sikerült hozzáadni a kifejezést, kérlek, próbáld újra"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kifejezés sikeresen frissítve",
            "ERROR_MESSAGE": "Nem sikerült frissíteni a kifejezést, kérlek, próbáld újra"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Kifejezés törlése",
          "DESCRIPTION": "Biztosan törölni szeretnéd ezt a kifejezést? A továbbiakban nem lesz érvényesítve a fordítás során.",
          "CONFIRM": "Törlés"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kifejezés sikeresen törölve",
          "ERROR_MESSAGE": "Nem sikerült törölni a kifejezést, kérlek, próbáld újra"
        }
      }
    }
  }
}
